import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyAY-dvSHy_AX1IstmZWE3CrNdBF-2vai3k",
  authDomain: "scrapmarket-d1930.firebaseapp.com",
  projectId: "scrapmarket-d1930",
  storageBucket: "scrapmarket-d1930.firebasestorage.app",
  messagingSenderId: "652691026344",
  appId: "1:652691026344:web:a2968c435f30dab828ad9d"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
// Long polling замість потокового з'єднання: на iPhone (Safari) потокове з'єднання з базою могло висіти до хвилини — ціни й оголошення не з'являлись
export const db = initializeFirestore(app, { experimentalForceLongPolling: true });
export const storage = getStorage(app);

export let messaging = null;
isSupported().then(supported => {
  if (supported) {
    try {
      messaging = getMessaging(app);
    } catch (e) {
      console.warn('Firebase Messaging init failed:', e.message);
    }
  } else {
    console.log('Firebase Messaging not supported on this browser/device');
  }
});